import React from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import withPageContainer from '../shared/page-container/with-page-container';
import withIntl from '../shared/intl-hoc';

import Calendar from '../shared/calendar/main';
import Filters from '../shared/filters/main';
import Table from '../shared/new-table/main';

import table from './table-initial-data';

import { selectors, actions } from './';

import './index.less';

function List({ intl, filters, calendar, rows, pagination, ...props }) {
	return (
		<div className='registration-analytics'>
			<div className='clearfix'>
				<Filters
					intl={intl} {...filters} filters={filters} // for crutch support
				/>
			</div>
			<div className='registration-analytics-actions'>
				<Calendar
					className='registration-analytics-calendar'
					intl={intl}
					{...calendar}
					onInit={calendar.calendarInit}
					onToggle={calendar.calendarToggle}
					onChange={calendar.calendarChange}
					onApply={calendar.calendarApply}
				/>
				<button
					className='ui-btn ui-btn-primary'
					onClick={props.apply}
				>
					{intl('Apply')}
				</button>
				<button
					className='ui-btn ui-btn-secondary ui-icon-clear'
					onClick={props.clear}
				/>
			</div>
			<Table
				table={table}
				rows={rows}
			/>
			{(rows.length < pagination.total) && (
				<div className='registration-analytics-button-wrapper'>
					<button
						className='ui-btn ui-btn-secondary registration-analytics-button'
						onClick={pagination.showMore}
					>
						{intl('Show more')}
					</button>
				</div>
			)}
		</div>
	);
}

function mapStateToProps(state) {
	return {
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		rows: selectors.select(state, 'data'),
		// -----------------------------------------
		filters: selectors.getFilters(state),
		calendar: selectors.getCalendar(state),
		pagination: selectors.getPagination(state)
	};
}

function mapDispatchToProps(dispatch) {
	return {
		...bindActionCreators(actions.own, dispatch),
		apply: () => dispatch(actions.apply()),
		clear: () => dispatch(actions.clear()),
		filters: bindActionCreators(actions.filters, dispatch),
		calendar: bindActionCreators(actions.calendar, dispatch),
		pagination: bindActionCreators(actions.pagination, dispatch)
	};
}

function mergeProps(stateProps, dispatchProps, ownProps) {
	return {
		...ownProps,
		...stateProps,
		...dispatchProps,
		filters: {
			...stateProps.filters,
			...dispatchProps.filters
		},
		calendar: {
			...stateProps.calendar,
			...dispatchProps.calendar
		},
		pagination: {
			...stateProps.pagination,
			...dispatchProps.pagination
		}
	};
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(
	withPageContainer(withIntl(List), { name: 'Registration analytics' })
);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/registration-analytics/main.js